import React, { useState, useEffect, useRef } from "react";
import { logIn, fetch, setCaixa, logOut } from "../../actions";
import { connect } from "react-redux";
import ContainerDefault from "../../components/ContainerDefault";
import ConsultaEstoque from "../ConsultaEstoque/ConsultaEstoque";
import TabelaBalcao from "./TabelaBalcao";
import ModalObs from "./ModalObs";
import Finalizar from "../Finalizar/Finalizar";
import Mensagens from "../../components/Mensagens";
import SelectPesq from "../../components/Selects/SelectPesq";
import { Tag, Tooltip } from "antd";
import EntregaConsulta from "../Entrega/EntregaConsulta";
import Recuperar from "../Recuperar/Recuperar";
import { useSave } from "../../components/Hooks/Conexao";
import { BtnDeletar, BtnGravar, BtnPadrao, BtnSair } from "../../components/Buttons";
import LoadingScreen from "../../components/LoadingScreen";
import { LabelPadrao, ModalPadrao } from "../../components/Base";
import useTotais from "../../components/Hooks/useTotais";
import Porcentagem from "../../Utils/Porcentagem";
import TabelaPadrao from "../../components/TabelaPadrao";
import { WarningOutlined } from "@ant-design/icons";
import roundCustom from "../../Utils/RoundCustom";
import SelectPesqProduto from "../../components/Selects/SelectPesqProduto";
import { useValidarUsuario } from "../../components/Hooks/useValidarUsuario";
import ModalServico from "./ModalServico";
import { useProdutoLote } from "../../Contexts/ProdutoLoteContext";
import ModalTransportadora from "./ModalTransportadora";

function Balcao(props) {
  const [venda, setVenda] = useState({});
  const [prodList, setProdList] = useState([]);
  const [linhaMarcada, setLinhaMarcada] = useState(0);
  const [showModal, setShowModal] = useState(null);
  const [validarCaixa, validando] = useSave(() => props.fetch().post("/caixa/get"), resp => props.setCaixa(resp.aberto));
  const [alteracaoPrecoDetalhe, setAlteracaoPrecoDetalhe] = useState({});
  const [validarUsuario, validandoUsuario] = useValidarUsuario(props.fetch);

  const permiteCriarServico = !props.dados?.parametros ? false : props.dados.parametros["PermiteCriarServico"];
  const permiteAlterarPreco = !props.dados?.parametros ? false : props.dados.parametros["PermiteAlterarPreco"];
  const permiteDiminuirQuantidade = !props.dados?.parametros ? false : props.dados.parametros["PermiteDiminuirQuantidadeItensVenda"];
  const permiteCriarEntrega = !props.dados?.parametros ? false : props.dados.parametros["PermiteCriarEntrega"];

  const disabled = !!venda?.numero && venda?.hasServico;
  const totais = useTotais(prodList, null, { valorFrete: venda.valorFrete });
  const online = props.online;
  const hasPendente = !!prodList.find(x => x.pendente);

  const { handleProdutoLote } = useProdutoLote();

  const clienteId = venda?.clienteId?.length ? venda.clienteId[0].id : 0;

  useEffect(() => validarCaixa(), []);

  useEffect(() => {
    if (!props.isCaixaAberto)
      limpar();
  }, [props.isCaixaAberto]);

  useEffect(() => {
    if (showModal)
      document.removeEventListener("keydown", keyDown);
    else
      document.addEventListener("keydown", keyDown);

    return () => document.removeEventListener("keydown", keyDown);
  }, [linhaMarcada, prodList, showModal, online]);


  useEffect(() => {

    if (prodList.length)
      prodList.forEach(x => addPrd(x, 0, true));

  }, [clienteId]);


  const keyDown = e => {

    if (e.key === "F2" || e.key === "F1" || e.key === "F6" || e.key === "F7" || e.key === "F8" || e.key === "F9" || e.key === "F10" || e.key === "F11" || e.key === "F12") {
      e.preventDefault();
      if (e.key === "F2" && linhaMarcada != null && online) setShowModal("cons");
      if (e.key == "F1") setShowModal("obs");
      if (e.key === "F6" && !!prodList?.length) setShowModal("limp");
      if (e.key == "F10" && !hasPendente && !!prodList?.length) setShowModal("orcamento");
      if (e.key == "F11" && permiteCriarEntrega) setShowModal("ent");
      if (e.key == "F12" && !!prodList?.length && !hasPendente) setShowModal("venda");
    }

    if (linhaMarcada >= 0 && !!prodList?.length && linhaMarcada != null) {
      var inputQtdMarc = document.querySelector(`#input-tabelabalcao-qtd-${linhaMarcada}`);
      var inputDescMarc = document.querySelector(`#input-tabelabalcao-desc-${linhaMarcada}`);

      const isFocused = (document.activeElement === inputQtdMarc || document.activeElement === inputDescMarc);

      if (e.key == "ArrowRight" && !!inputQtdMarc && !isFocused)
        inputQtdMarc.focus();

      if (e.key == "ArrowUp") {
        var linha = prodList[linhaMarcada - 1];
        if (linha && !isFocused) setLinhaMarcada(linhaMarcada - 1);
      }

      if (e.key == "ArrowDown") {
        var linha = prodList[linhaMarcada + 1];
        if (linha && !isFocused) setLinhaMarcada(linhaMarcada + 1);
      }
    }
  };

  const limpar = () => {
    setProdList([]);
    setLinhaMarcada(0);
    setVenda({});
    setAlteracaoPrecoDetalhe({});
  };

  const fecharModal = () => { setShowModal(null); };

  const onSaved = focus => {
    fecharModal();
    limpar();

    if (focus)
      setTimeout(() => document.getElementById("pesqproduto").focus(), 150);
  };

  const recuperar = v => {
    setVenda({ ...v, clienteId: !!v.clienteId ? v.clienteId : [], vendedorId: !!v.vendedorId ? v.vendedorId : [] });
    setProdList([...v.produtos, ...v.servicos.map(x => ({ ...x, isServico: true }))].map(x => ({ ...x, qtd: !!x.qtdPaga ? x.qtdPaga : x.qtd, descPorc: Porcentagem.obter(x.desconto, x.valorTotal + x.desconto) })));
    setAlteracaoPrecoDetalhe({ ...v, recuperado: true, modalAberto: false });
    fecharModal();
  };

  const limparRecuperar = () => !alteracaoPrecoDetalhe?.recuperado ? limpar() : setAlteracaoPrecoDetalhe({ ...alteracaoPrecoDetalhe, modalAberto: false });

  if (validando)
    return <LoadingScreen loading={true} />;


  const addPrd = (addedProd, qtdInformada, manterQtd) => {
    if (!addedProd)
      return;

    const aux = [...prodList];

    const inx = aux.findIndex(x => x.id == addedProd.id && x.isServico == addedProd.isServico && x.idBalanca == addedProd.idBalanca);
    const prdExist = aux[inx];

    if (prdExist?.pendente)
      return;

    let qtd = (!!qtdInformada ? qtdInformada : 1) + (prdExist?.qtd || 0);

    if (!addedProd.isFracionado)
      qtd = Math.floor(qtd);

    if (manterQtd)
      qtd = prdExist?.qtd || 0;

    const prd = {
      ...addedProd,
      qtd: qtd,
      qtdTotal: qtd,
      qtdExtra: 0,
      valorUn: addedProd.preco,
      valorTotal: 0, desconto: 0,
      descPorc: 0,
      descontoPromocao: prdExist?.descontoPromocao,
      disableQtd: !!addedProd.isBalanca && qtd != 1,
      pendente: true
    };

    handleProdutoLote(prd, lotes => getPrdPromocao({ ...prd, lotes }));

    const divTabelaBalcao = document.getElementById("tabelabalcao");
    if (!prdExist && !!divTabelaBalcao)
      divTabelaBalcao.scrollTop = divTabelaBalcao.scrollHeight;
  };

  const getPrdPromocao = prd => props.fetch().post(`/descontopromocao/getbyprd/${prd.id}/${clienteId}`)
    .then(res => {
      const promocoes = res.data;
      prd.promocoes = promocoes;
      prd.pendente = false;
      changeQtd(prd.qtd, prd);
    })
    .catch(() => {
      prd.pendente = false;
      setProdList(list => list.map(x => x.id == prd.id ? prd : x));
      Mensagens.showErro(`Erro ao obter os dados do produto ${prd.descricao}, por favor tente novamente.`);
    });

  function formatarPrdPromo(qtd, prd, descontoPromocao, validacao, modalidadeId, showMsg) {
    prd.descontoPromocaoAutorizacao = null;
    //nova promoção informada ou desvinculada
    if (!!descontoPromocao) {
      if (!!descontoPromocao?.id)
        prd.descontoPromocao = descontoPromocao;
      else {
        prd.descontoPromocao = null;
        prd.descPorc = 0;
      }
    }
    else {
      //verifica se existe promoção melhor para produtos sem promoção ou com promoção automática
      if (!validacao) {
        const promoAtual = prd.descontoPromocao;
        const promos = prd.promocoes?.filter(x => !!modalidadeId ? (x.todasModalidades || !!x.modalidades.find(s => s.id == modalidadeId)) : x.isAplicadoAutomatico);

        if (!!promoAtual && !promos.find(x => x.id == promoAtual.id))
          promos.push({ ...prd.descontoPromocao });

        const prdsPromo = [];
        promos?.filter(x => qtd >= x.qtdMinima && qtd <= x.qtdMaxima).forEach(x => {
          let prdFmt = formatarPrdPromo(qtd, { ...prd }, x, true);
          prdsPromo.push(prdFmt);
        });

        prd.descontoPromocao = prdsPromo.length ? prdsPromo.sort((a, b) => (a.valorTotal / a.qtdTotal) > (b.valorTotal / b.qtdTotal) ? 1 : -1)[0].descontoPromocao : null;

        if (showMsg && !!prd.descontoPromocao && promoAtual?.id != prd.descontoPromocao?.id)
          Mensagens.showInfo(`${prd.descontoPromocao.descricao} selecionada`);
      }
    }

    let valorBruto = roundCustom(prd.valorUn * qtd);
    prd.qtd = qtd;
    prd.qtdExtra = 0;

    if (!prodList.find(s => s.id == prd.id && s.idBalanca == prd.idBalanca) && prd.isBalanca && qtd != 1) {
      valorBruto = qtd;
      qtd = roundCustom(qtd / prd.valorUn, 8);
      prd.qtd = qtd;
    }

    //verifica se existe promoção válida e aplica os valores com base no tipo da promoção
    if (!!prd.descontoPromocao && qtd >= prd.descontoPromocao.qtdMinima && qtd <= prd.descontoPromocao.qtdMaxima) {

      if (prd.descontoPromocao.tipo == 'DescontoPorcentagem' || prd.descontoPromocao.tipo == "Tabela") {
        prd.descPorc = prd.descontoPromocao.valor;
        prd.desconto = Porcentagem.calcular(prd.descPorc, valorBruto);
      }
      else if (prd.descontoPromocao.tipo == 'ValorFixo' || prd.descontoPromocao.tipo == "TabelaValorFixo") {
        prd.desconto = roundCustom(valorBruto - prd.descontoPromocao.valor * qtd);
        prd.descPorc = Porcentagem.obter(prd.desconto, valorBruto);
      }
      else if (prd.descontoPromocao.tipo == 'DescontoFixo') {
        prd.desconto = roundCustom(prd.descontoPromocao.valor * qtd);
        prd.descPorc = Porcentagem.obter(prd.desconto, valorBruto);
      }
      else if (prd.descontoPromocao.tipo == 'Quantidade') {
        prd.desconto = 0;
        prd.descPorc = 0;
        prd.qtdExtra = calcularQtdExtra(qtd, prd.descontoPromocao.valor, prd.descontoPromocao.qtdMinima);
      }
    }
    else if (!!prd.descontoPromocao) {
      //remove o desconto para promoção inválida
      prd.descPorc = 0;
      prd.desconto = 0;
    }
    else
      prd.desconto = Porcentagem.calcular(prd.descPorc, valorBruto);

    if (prd.descPorc > 100) {

      prd.descPorc = 0;
      prd.desconto = 0;
      prd.descontoPromocao = null;
      if (showMsg && !validacao)
        Mensagens.showErro("Desconto é maior que o valor do produto.");
    }

    prd.qtdTotal = prd.qtd + prd.qtdExtra;
    prd.valorTotal = roundCustom(valorBruto - prd.desconto);

    return prd;
  }

  const changeQtd = (qtdExt, prdExt, descontoPromocaoExt) => {
    prdExt.descontoPromocaoAutorizacao = null;

    const prdRet = formatarPrdPromo(qtdExt, prdExt, descontoPromocaoExt, false, null, true);
    const aux = [...prodList];
    const inx = aux.findIndex(s => s.id == prdRet.id && s.isServico == prdRet.isServico && s.idBalanca == prdExt.idBalanca);

    if (inx > -1 && (!!prdExt.idBalanca || !prdRet.isBalanca))
      aux[inx] = prdRet;
    else
      aux.push({ ...prdRet, idBalanca: prdRet.isBalanca ? prodList.filter(x => x.id == prdRet.id && !x.isServico).length + 1 : null });

    setProdList(aux);
  };

  return <>
    <ContainerDefault loading={validando || validandoUsuario} online={online}>
      {!props.isCaixaAberto && <div style={{ width: "100%", height: "100%", position: "absolute", cursor: "not-allowed", backgroundColor: "rgba(120, 120, 120,0.5)", top: 0, left: 0, zIndex: 100, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div style={{ borderRadius: 10, padding: 20, userSelect: "none" }} className="background-color-menu box-shadow-padrao">
          <span className="font-color-menu" style={{ textAlign: "center", margin: 0, letterSpacing: 0.5, fontSize: "2rem", display: "block" }}>Caixa fechado</span>
          <span className="font-color-menu">Abra o caixa para efetuar lançamentos</span>
        </div>
      </div>}
      <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 70px)", paddingBottom: 0, maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "flex-end", width: "65%" }}>
            <div style={{ width: "50%", marginRight: 10 }}>
              <SelectPesq tabIndex={1} placeholder="Pesquisar vendedor" maxTagTextLength={30} title="Vendedor" modelo="vendedor" onChange={v => setVenda({ ...venda, vendedorId: v })} value={venda.vendedorId} />
            </div>
            <div style={{ width: "50%" }}>
              <SelectPesq tabIndex={2} titleCustom placeholder="Pesquisar cliente" maxTagTextLength={30} title="Cliente" modelo="cliente" onChange={v => { setVenda({ ...venda, clienteId: v }); console.log(v); }} value={venda.clienteId} showAdd showEdit />
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            {permiteCriarEntrega && <BtnPadrao disabled={!online} onClick={() => setShowModal("ent")} style={{ marginRight: 10 }}>Entregas (F11)</BtnPadrao>}
            <BtnPadrao disabled={!online || prodList?.length || !!venda?.numero} onClick={() => setShowModal("rec")}>Recuperar</BtnPadrao>
          </div>
        </div>
        {!!venda.numero && <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
          <Tag style={{ padding: 5 }}> <LabelPadrao noMargin>Número: {venda.numero}</LabelPadrao></Tag>
          <Tooltip title="Limpar dados recuperados"><BtnDeletar style={{ marginRight: 5 }} showConfirm small onOk={limpar} /></Tooltip>
          {venda.contemAlteracao && <Tooltip title="Ver alterações nos preços">
            <BtnWarning warning onClick={() => setAlteracaoPrecoDetalhe({ ...alteracaoPrecoDetalhe, modalAberto: true })} />
          </Tooltip>}
        </div>}

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <div style={{ width: "100%" }}>
            <LabelPadrao>Código\Ean\Descrição</LabelPadrao>
            <SelectPesqProduto tabIndex={3} nextTab={3} onChange={addPrd} online={props.online} onClick={() => setLinhaMarcada(null)} tipo="produto" disabled={disabled} id="pesqproduto" />
          </div>
          {permiteCriarServico && <BtnPadrao style={{ marginLeft: 10, width: 130 }} onClick={() => setShowModal("serv")} disabled={disabled}>Incluir serviço</BtnPadrao>}
        </div>
        <TabelaBalcao
          disabled={disabled}
          prodList={prodList}
          totais={totais}
          linhaMarcada={linhaMarcada}
          setLinhaMarcada={setLinhaMarcada}
          online={props.online}
          onChangeQtd={changeQtd}
          onChangePreco={(v, prdRef) => changeQtd(prdRef.qtd, { ...prdRef, valorUn: v, preco: v })}
          toggleTipoDesconto={prdRef => {
            const aux = [...prodList];
            const prod = aux[aux.findIndex(s => s.id == prdRef.id && s.isServico == prdRef.isServico && s.idBalanca == prdRef.idBalanca)];
            prod.isValor = !prod.isValor;

            setProdList(aux);
          }}
          onChangeDesconto={(v, prdRef) => {
            const aux = [...prodList];
            const prd = aux[aux.findIndex(s => s.id == prdRef.id && s.isServico == prdRef.isServico && s.idBalanca == prdRef.idBalanca)];

            const valorBruto = prd.valorUn * prd.qtd;

            if (prd.isValor) {
              prd.desconto = v > valorBruto ? valorBruto : v;
              prd.descPorc = Porcentagem.obter(prd.desconto, valorBruto);
            }
            else {
              prd.descPorc = v;
              prd.desconto = Porcentagem.calcular(prd.descPorc, valorBruto);
            }

            prd.valorTotal = roundCustom(valorBruto - prd.desconto);
            setProdList(aux);
          }}
          onDelete={x => validarUsuario("excluirItensVenda", `Item ${x.codigo} foi removido da venda`, () => {
            const aux = [...prodList];
            aux.splice(aux.findIndex(s => s.id == x.id && s.isServico == x.isServico && s.idBalanca == x.idBalanca), 1);
            setProdList(aux);
          })}
          onChangeObs={prd => {
            const aux = [...prodList];
            aux[aux.findIndex(s => s.id == prd.id && s.isServico == prd.isServico && s.idBalanca == prd.idBalanca)].obs = prd.obs;

            setProdList(aux);
          }}
          onChangeLote={prd => handleProdutoLote(prd, lotes => {
            const aux = [...prodList];
            const inx = aux.findIndex(x => x.id == prd.id);

            aux[inx].lotes = lotes;
            setProdList(aux);
          }, props.fetch)}
          formatarPrdPromo={formatarPrdPromo}
          onLimparClick={() => setShowModal("limp")}
          onConsultaClick={() => !!prodList[linhaMarcada]?.id && setShowModal("cons")}
          permiteAlterarPreco={permiteAlterarPreco}
          permiteDiminuirQuantidade={permiteDiminuirQuantidade}
          validarUsuario={validarUsuario}
          validandoUsuario={validandoUsuario}
        />
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <div>
            <BtnPadrao onClick={() => setShowModal("obs")}>Obs. Venda (F1)</BtnPadrao>
            <BtnPadrao style={{ marginLeft: 10 }} onClick={() => setShowModal("transportadora")} disabled={!prodList.length}>Dados transporte</BtnPadrao>
          </div>
          <div>
            <BtnPadrao onClick={() => setShowModal("orcamento")} disabled={hasPendente || !prodList.length || !!venda?.numero} style={{ marginRight: 10 }} ghost>Orçamento (F10)</BtnPadrao>
            <BtnPadrao data-cy="btn-fin" onClick={() => setShowModal("venda")} disabled={!prodList.length || hasPendente}>Finalizar (F12)</BtnPadrao>
          </div>
        </div>
      </div>
      {!!props.atualizacao && <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translate(-50%, -50%)' }} className="blink_me"><LabelPadrao style={{ fontWeight: 'normal' }}>Nova versão disponível, reinicie para atualizar</LabelPadrao></div>}
    </ContainerDefault>

    <ModalServico visible={showModal == "serv"} onCancel={fecharModal} onOk={ret => {
      const aux = [...prodList];

      ret.forEach(x => {
        const inx = aux.findIndex(s => s.isServico && s.id == x.id);
        if (inx >= 0)
          aux[inx] = x;
        else
          aux.push(x);
      });

      setProdList(aux);

      fecharModal();
    }} online={props.online} />

    <ModalObs visible={showModal === "obs"} onCancel={fecharModal} observacao={venda.observacoes} onOk={v => { setVenda({ ...venda, observacoes: v }); fecharModal(); }} />

    <ModalTransportadora visible={showModal === "transportadora"} dados={venda?.dadosFreteNF} onCancel={fecharModal} onOk={v => { setVenda({ ...venda, valorFrete: v.valorFreteNf || 0, dadosFreteNF: v }); fecharModal(); }} />

    <ConsultaEstoque visible={showModal === "cons" && !prodList[linhaMarcada]?.isServico} onCancel={fecharModal} id={prodList[linhaMarcada]?.id} />

    <Recuperar visible={showModal === "rec"} onCancel={fecharModal} onOk={v => {
      if (v.contemAlteracao) {
        setAlteracaoPrecoDetalhe({ ...v, modalAberto: true });
        return fecharModal();
      }

      recuperar(v);
    }} />

    <EntregaConsulta onCancel={fecharModal} visible={showModal === "ent" && online} />

    <Finalizar visible={showModal === "venda" || showModal === "orcamento"} venda={{ ...venda, itensVenda: prodList, isOrcamento: showModal === "orcamento" }} onCancel={fecharModal} onOk={onSaved} tabIndex={4} />

    <ModalPadrao visible={showModal === "limp"} width={650} onCancel={fecharModal} footer={<>
      <BtnGravar txt="Sim" onClick={() => validarUsuario("limparVenda", `Produtos ${prodList.map(x => x.codigo).join(',')} foram removidos da venda`, () => { limpar(); fecharModal(); })} />
      <BtnSair onClick={fecharModal} />
    </>}>
      <div style={{ textAlign: "center" }}>
        <h2>Deseja limpar a lista de produtos?</h2>
        <p>Uma vez limpa não poderá ser restaurada!</p>
      </div>
    </ModalPadrao>

    <ModalPadrao title="Alterações nos preços" visible={alteracaoPrecoDetalhe.modalAberto} width={850} closable={false} footer={<>
      {!alteracaoPrecoDetalhe.recuperado && <BtnPadrao onClick={() => recuperar(alteracaoPrecoDetalhe)}>Recuperar</BtnPadrao>}
      <BtnSair onClick={limparRecuperar} />
    </>}>
      <div style={{ minHeight: 350 }}>
        <TabelaPadrao columns={columns} data={([...(alteracaoPrecoDetalhe?.produtos || []), ...(alteracaoPrecoDetalhe?.servicos || [])])?.filter(x => x.precoAlterado || x.precoAlteradoEmGarantia)} />
      </div>
    </ModalPadrao>
  </>;
}

const columns = [
  {
    Header: "Produto",
    accessor: "descricao",
    Cell: props => <p style={{ margin: 0 }}>{props.row.original.codigo} - {props.row.original.descricao}</p>
  },
  {
    Header: "Valor unitário",
    accessor: "valorUn",
    tipo: "dec",
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    tipo: "dec",
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    tipo: "dec",
  },
  {
    Header: "Valor total",
    accessor: "valorTotal",
    tipo: "dec",
  },
  {
    Header: " ",
    accessor: " ",
    Cell: props => {
      const row = props.row.original;
      return <Tooltip title={row.precoAlterado ? "Valores recalculados devido a alteração no preço" : "Preço do produto mudou porém o valor foi mantido devido ao período de garantia"}>
        <BtnWarning warning={row.precoAlteradoEmGarantia} />
      </Tooltip>;
    },
    tipo: "right"
  }
];

function BtnWarning(props) {
  return <WarningOutlined
    {...props}
    className={`cad-icon-small ${props.warning ? "row-amarelo" : "row-verde"}`}
    style={{ cursor: "pointer", borderRadius: 50, padding: 3, ...props.style }}
  />;
}

const calcularQtdExtra = (qtd, valor, qtdMinima) => Math.trunc(qtd / qtdMinima) * valor;

const mapStateToProps = state => ({ isCaixaAberto: state.auth.caixaAberto, online: state.connection.online, dados: state.dados, atualizacao: state.atualizacao });

export default connect(mapStateToProps, { logIn, fetch, setCaixa, logOut })(Balcao);